/* eslint-disable default-param-last */
import keyBy from 'lodash/keyBy'
import forEach from 'lodash/forEach'

export const SET_SELECTED_CONDITION = 'CONDITION_SET_SELECTED_CONDITION'
export const SET_SELECTED_PREVIOUS_CONDITION = 'CONDITION_SET_SELECTED_PREVIOUS_CONDITION'
export const UPDATE_ENCOUNTER_CONDITIONS = 'CONDITION_UPDATE_ENCOUNTER_CONDITIONS'
export const UPDATE_PREVIOUS_CONDITIONS = 'CONDITION_UPDATE_PREVIOUS_CONDITIONS'

export const UPDATE_EDIT_CONDITION = 'CONDITION_UPDATE_EDIT_CONDITION'
export const RESET_EDIT_CONDITION = 'CONDITION_RESET_EDIT_CONDITION'

export const NOT_ADDRESSED = 'CONDITION_NOT_ADDRESSED'
export const ADDRESSED = 'CONDITION_ADDRESSED'

export const CLEAR_STATE = 'CONDITION_CLEAR_STATE'
export const CLEAR_ALL_STATE = 'CLEAR_ALL_STATE'

type ConditionItem = {
  id: string
  conditionCode?: string
  conditionClassifierId?: string
}

type ConditionState = {
  conditionIndex: number | undefined
  previousConditionIndex: number | undefined
  editConditionId: string | undefined
  list: {
    byId: Record<string, ConditionItem>
  }
  previousList: {
    byId: Record<string, ConditionItem>
    byConditionClassifierId: Record<string, ConditionItem[]>
  }
}

type Action = {
  type: string
  payload?: any
}

const initState: ConditionState = {
  conditionIndex: undefined,
  previousConditionIndex: undefined,
  editConditionId: undefined,
  list: {
    byId: {}
  },
  previousList: {
    byId: {},
    byConditionClassifierId: {}
  }
}

export default (
  state: ConditionState = initState,
  action: Action
): ConditionState => {
  switch (action.type) {
    case CLEAR_STATE:
    case CLEAR_ALL_STATE:
      return initState

    case SET_SELECTED_CONDITION:
      return {
        ...state,
        conditionIndex: action.payload
      }

    case SET_SELECTED_PREVIOUS_CONDITION:
      return {
        ...state,
        previousConditionIndex: action.payload
      }

    case RESET_EDIT_CONDITION:
      return {
        ...state,
        editConditionId: undefined
      }

    case UPDATE_EDIT_CONDITION:
      return {
        ...state,
        editConditionId: action.payload
      }

    case NOT_ADDRESSED: {
      const condition = {
        ...state.list.byId[action.payload],
        conditionCode: 'OPEN'
      }
      return {
        ...state,
        list: {
          byId: {
            ...state.list.byId,
            [action.payload]: condition
          }
        }
      }
    }

    case ADDRESSED: {
      const condition = {
        ...state.list.byId[action.payload],
        conditionCode: 'ADDRESSED'
      }
      return {
        ...state,
        list: {
          byId: {
            ...state.list.byId,
            [action.payload]: condition
          }
        }
      }
    }

    case UPDATE_ENCOUNTER_CONDITIONS:
      return {
        ...state,
        list: {
          byId: keyBy(
            action.payload,
            (condition: ConditionItem) => condition.id
          )
        }
      }

    case UPDATE_PREVIOUS_CONDITIONS: {
      if (!action.payload) {
        return {
          ...state,
          previousList: {
            byId: {},
            byConditionClassifierId: {}
          }
        }
      }
      const conditionClassifierList: Record<string, ConditionItem[]> = {}
      forEach(
        action.payload,
        (previous: ConditionItem) => {
          const classifierId = previous.conditionClassifierId || ''
          if (!conditionClassifierList[classifierId]) {
            conditionClassifierList[classifierId] = []
          }
          conditionClassifierList[classifierId].push(previous)
        }
      )
      return {
        ...state,
        previousList: {
          byId: keyBy(
            action.payload,
            (previous: ConditionItem) => previous.id
          ),
          byConditionClassifierId: conditionClassifierList
        }
      }
    }

    default:
      return state
  }
}
